<template>
  <div>
    <!-- 头部导航 -->
    <Header v-if="newsList.length!=0"/>

    <!-- 顶部横幅 -->
    <div class="top-banner" v-if="newsList.banner">
      <img
        :src="newsList?.banner[0].thumb"
        alt=""
        style="width: 100%; height: 100%"
      />
    </div>
    <div class="company-intro" v-if="newsList.length!=0">
      <!-- 导航栏 -->
      <div
        style="
          padding-bottom: 50px;
          width: 1100px;
          margin: 0 auto;
          background-color: #fff;
        "
      >
        <el-menu
          mode="horizontal"
          :default-active="activeIndex"
          class="gradient-nav"
        >
          <el-menu-item
            index="1"
            v-for="(item, index) in list"
            :key="index"
            :style="'width: ' + 100 / list.length + '%'"
            @click="goto(item)"
            >{{ item.name }}</el-menu-item
          >
        </el-menu>
      </div>

      <!-- 内容区域 -->
      <div class="content">
        <div style="margin: 0 auto">
          <div>
            <!-- 响应式栅格布局 -->
            <el-row :gutter="24">
              <el-col
                :md="8"
                :sm="12"
                :xs="24"
                v-for="(item, index) in newsList?.list?.data"
                :key="index"
              >
                <div class="news-item" @click="gotodetail(item)">
                  <img
                    :src="item.thumb"
                    alt="新闻图片"
                    class="news-img"
                    v-if="item.thumb"
                  />
                  <div style="height: 100px; background-color: #f1ece1">
                    <div class="news-title">{{ item.name }}</div>
                    <div class="sec-title"></div>
                    <div class="news-date">{{ item.posttime }}</div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div style="padding: 30px 0; background-color: #f6f6f6" v-if="newsList.length!=0">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="obj.page"
        :page-size="newsList?.list?.per_page"
        layout="total, prev, pager, next, jumper"
        :total="newsList?.list?.total"
      >
      </el-pagination>
    </div>
    <!-- 底部 -->
    <Footer v-if="newsList.length!=0"/>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import { NewsList } from "@/api/index";

export default {
  name: "About",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      activeIndex: "1", // 默认选中“公司介绍”
      newsList: [],
      obj: {
        id: "",
        unit_id: "",
        page: 1,
      },
      list: [],
      list1: [
        {
          name: "Corporate News",
          type: 2,
          id: 16,
        },
        // {
        //   name: "行业动态",
        //   type: 2,
        //   id: 17,
        // },
        {
          name: "Reports",
          type: 2,
          id: 18,
        },
        // {
        //   name: "企业荣誉",
        //   type: 2,
        //   id: 19,
        // },
      ],
      list2: [
        {
          name: "Health Food",
          type: 2,
          id: 11,
        },
        {
          name: "Health Equipment",
          type: 2,
          id: 12,
        },
        {
          name: "Cosmetics",
          type: 2,
          id: 13,
        },
        {
          name: "Cleaning Supplies",
          type: 2,
          id: 14,
        },
      ],
      list3: [
        {
          name: "Charity Events",
          type: 2,
          id: 8,
        },
        {
          name: "Social Recognition",
          type: 2,
          id: 9,
        },
      ],
      list4:  [
        {
          name: "About us",
          type: 1,
          id: 70,
        },
        {
          name: "Management",
          type: 1,
          id: 71,
        },
        {
          name: "Corporate Culture",
          type: 1,
          id: 72,
        },
        {
          name: "Honors ",
          type: 2,
          id: 6,
        },
        {
          name: "R&D",
          type: 1,
          id: 73,
        },
        {
          name: "Corporate Event",
          type: 1,
          id: 75,
        },
      ],
    };
  },
  created() {
    this.updateObjParams();
    this.getNewsList(); // 重新加载数据
  },
  watch: {
    $route(to) {
      // 路由参数变化时，更新数据
      this.updateObjParams();
      this.getNewsList(); // 重新加载数据
    },
  },

  methods: {
    updateObjParams() {
      this.obj.id = this.$route.query.id; // 同步最新的 id
      this.obj.unit_id = this.$route.query.unit_id; // 同步最新的 type
       this.obj.page = 1
      console.log(this.obj.id);

      switch (this.obj.unit_id) {
        case "2":
          this.list = this.list1;
          break;
        case "3":
          this.list = this.list2;
          break;
        case "4":
          this.list = this.list3;
          break;
        case "1":
          this.list = this.list4;
          break;
      }
    },
    goto(item) {
      this.obj.id = item.id;
      this.obj.page = 1
      if (item.type == 2) {
        this.getNewsList(this.obj); // 将id拼接到路由路径中
      } else {
        this.$router.push({
          path: `/about?id=${item.id}&unit_id=${this.obj.unit_id}`, // 将id拼接到路由路径中
        });
      }
    },
    handleCurrentChange(val) {
      console.log(456, val);
      this.obj.page = val;
      this.getNewsList(this.obj);
    },
    getNewsList(obj) {
      
      NewsList(this.obj).then((res) => {
        console.log(res);
        this.newsList = res;
      });
    },
    gotodetail(item) {
      console.log(item);

      this.$router.push({
        path: `/about?id=${item.pid}&unit_id=${this.obj.unit_id}`, // 将id拼接到路由路径中
      });
    },
  },
};
</script>

<style scoped>
.news-item {
  margin-bottom: 50px;
  overflow: hidden;
}

.news-img {
  width: 346px;
  height: 207px;
  display: inline-block;
  transition: 0.5s;
}
.news-item:hover img {
  transform: scale(1.05);
  opacity: 0.6;
}
.news-title {
  padding: 5px 10px;
  font-size: 16px;
  color: #000;
  padding-bottom: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.sec-title {
  padding: 5px 25px;
  font-size: 13px;
  color: #000;
  padding-top: 0;
}
.news-date {
  font-size: 12px;
  margin-right: 10px;
  text-align: right;
  margin-top: 5px;
}
/* 导航栏整体：线性渐变背景 */
.gradient-nav {
  background: linear-gradient(
    to right,
    #e6ddce,
    #c4a35f
  ); /* 从浅棕到深棕的渐变 */
  border: none !important; /* 移除 Element UI 默认边框 */
}

/* 菜单项基础样式 */
.gradient-nav .el-menu-item {
  color: #554422 !important; /* 文字颜色 */
  height: 65px !important;
  line-height: 65px !important;
  border: none !important; /* 移除默认边框 */
  width: 20%;
  font-size: 18px;
  font-weight:700;
  padding: 16px 0;
}

/*  hover 状态 */
.gradient-nav .el-menu-item:hover {
  background-color: rgba(
    255,
    255,
    255,
    0.2
  ) !important; /* 半透明白色 hover 背景 */
}

/* 激活（选中）状态 */
.gradient-nav .el-menu-item.is-active {
  background-color: rgba(
    255,
    255,
    255,
    0.3
  ) !important; /* 激活时更明显的半透背景 */
  color: #333 !important; /* 激活时文字加深 */
  width: 20%;
}

.company-intro {
  color: #333;
  background-color: #f6f6f6;
}

/* 顶部横幅 */
.top-banner {
  text-align: center;
  color: #fff;
  min-width: 870px;
}

/* 导航栏 */
.el-menu--horizontal {
  border-bottom: none;
  width: 1100px;
  background-color: #fff;
}

.el-menu-item {
  padding: 0 20px !important;
  height: 40px !important;
  line-height: 40px !important;
}

/* 内容区 */
.content {
  max-width: 1100px;
  margin: 0 auto;
  background-color: #fff;
}

.section-title {
  font-size: 24px;
  margin-bottom: 20px;
  color: #333;
}

h3 {
  text-align: left;
  color: #666;
  margin: 15px 0;
}

p {
  text-align: left;
  margin: 10px 0;
  text-indent: 2em; /* 首行缩进2字符 */
}

/* 底部图片 */
.bottom-img {
  width: 100%;
  height: auto;
}
</style>
